import * as React from 'react'
import { SVGProps } from 'react'
export const NewsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    {...props}
  >
    <path
      fill="#858585"
      d="M29.75 5.25c.966 0 1.75.784 1.75 1.75v5.25h5.25c.967 0 1.75.784 1.75 1.75v17.5a5.25 5.25 0 0 1-5.25 5.25H8.75A5.25 5.25 0 0 1 3.5 31.5V7c0-.966.784-1.75 1.75-1.75h24.5ZM31.5 31.5a1.75 1.75 0 0 0 3.5 0V15.75h-3.5V31.5ZM7 31.5a1.75 1.75 0 0 0 1.75 1.75H28.3a5.243 5.243 0 0 1-.3-1.75V8.75H7V31.5Zm15.75-12.25a1.75 1.75 0 1 1 0 3.5h-7a1.75 1.75 0 1 1 0-3.5h7Zm0-7a1.75 1.75 0 1 1 0 3.5h-10.5a1.75 1.75 0 1 1 0-3.5h10.5Z"
    />
  </svg>
)
